import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Loading from '../../../components/Loading';
/* import { withAuthenticationRequired } from '@auth0/auth0-react'; */
import { Backdrop, Card, CardContent, Modal } from '@mui/material';
import useCompra from '../../../components/perfil/Compras/VerCompra/useCompra';
import moment from 'moment';
import NotDesign from "../../../assets/design-not-available.png";
import { config } from '../../../services/config';
import { ArrowBack, CalendarTodayOutlined, EmailOutlined } from '@mui/icons-material';
import withAuthenticationRequired from '../../../components/ProtectedRoutes/withAuthenticationRequired';
import { api } from '../../../services/api';
const apiOrigin = config.URL_API;


const getItemImageUrl = (item, isTicket = false) => {
  // si es ticket, usar diseño personalizado
  if (isTicket) {
    return `${apiOrigin}/static/eventos/tickets/ticket${item.id}.png?t=${Date.now()}`;
  }

  // si es voucher, que no maneja diseño, usar NotDesign
  return NotDesign;
};

const ReciboVenta = () => {
  const { id, idventa } = useParams();
  const history = useHistory();
  const { compra, loading, unauthorized } = useCompra(idventa);
  const [expandedImage, setExpandedImage] = useState(null);
  const [resendingEmail, setResendingEmail] = useState(false);
  if (unauthorized) {
    return null;
  }

  const handleExpandImage = (ticketId) => {
    setExpandedImage(ticketId);
  }

  const handleCloseImage = () => {
    setExpandedImage(null);
  }

  const handleResendEmail = async (compraId, email) => {
    if (window.confirm(`¿Confirmar reenvío de tickets a ${email}?`)) {
      setResendingEmail(true);

      try {
        const response = await api.email.reSend(compraId);

        if (response.status === 'success') {
          alert(`✅ ${response.message}`);
        } else {
          alert(`❌ Error: ${response.message}`);
        }
      } catch (error) {
        console.error('Error reenviando emails:', error);
        alert(`❌ Error reenviando emails: ${error.message}`);
      } finally {
        setResendingEmail(false);
      }
    }
  };

  if (loading) {
    return <Loading />
  }

  const renderItems = (items, itemType) => {
    const isTicket = itemType === 'ticket';

    return items?.map((item) => (
      <Card sx={{
        maxWidth: "350px",
        height: "auto",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        overflow: 'hidden'
      }} key={`${itemType}-${item.id}`}>
        <div style={{ position: 'relative' }}>
          <img
            src={isTicket
              ? `${apiOrigin}/static/eventos/tickets/ticket${item.id}.png?t=${Date.now()}`
              : NotDesign
            }
            alt={`${isTicket ? 'Ticket' : 'Voucher'} ${item.id}`}
            style={{ width: "100%", display: "block" }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = NotDesign;
            }}
          />
        </div>
        <CardContent>
          <h5 style={{
            fontWeight: 600,
            color: '#0B0060',
            marginBottom: '4px',
            fontFamily: "Bricolage Grotesque",
            fontSize: '18px'
          }}>{compra?.carrito?.evento?.evento}</h5>
          <p style={{
            color: '#525252',
            margin: '8px 0',
            fontSize: '14px',
            fontWeight: 500,
            fontFamily: "Bricolage Grotesque"
          }}>{item?.tarifa?.concepto}</p>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
            <CalendarTodayOutlined sx={{ fontSize: "14px", color: '#5656ff', marginRight: "5px" }} />
            <span style={{
              fontSize: '14px',
              color: '#525252',
              fontFamily: "Bricolage Grotesque"
            }}>
              {moment(item.tarifa?.fechas?.[0]?.fecha.hora_inicio).clone().local().format("MMMM DD, YYYY")}
            </span>
          </div>
          <div style={{
            marginTop: '12px',
            display: 'flex',
            textAlign: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            color: '#71717A',
          }}>
            <span>{isTicket ? 'Ticket' : 'Voucher'} #{item.id}</span>
          </div>
        </CardContent>
      </Card>
    ));
  };

  /* console.log("compra", compra); */
  return (
    <div className="container-fluid container-sm mx-auto mt-1 mb-5">
      <div className="d-flex flex-row justify-content-between flex-wrap" style={{ backgroundColor: "white"/* , borderTop: "1px solid #E4E4E7" */, borderBottom: "1px solid #E4E4E7", padding: "10px", marginBottom: "20px" }}>
        <div className='d-flex flex-row align-items-center gap-4'>
          <button type="button" onClick={() => history.push(`/eventos/${id}/ventas`)}>
            <ArrowBack />
          </button>
          <div className='d-flex flex-row align-items-center gap-4'>
            <p className='mb-0' style={{ fontWeight: "600" }}>Compra #: {compra?.id}</p>
            <span style={{ borderRight: "1px solid #e4e4e7", height: "100%" }}></span>
            <p className='mb-0'>Comprador: <span style={{ fontWeight: "600" }}>{compra?.email}</span> </p>
          </div>
        </div>
        <div style={{ marginTop: window.innerWidth <= 576 ? "10px" : "0" }}>
          <button
            type="button"
            onClick={() => handleResendEmail(compra?.id, compra?.email)}
            disabled={resendingEmail}
            className="btn btn-success btn-sm d-flex align-items-center"
            title={`Reenviar tickets a ${compra?.email}`}
            style={{
              gap: '4px',
              backgroundColor: "#5656FF",
              color: "white",
              borderColor: "#5656FF",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: window.innerWidth <= 576 ? "13px" : "14px",
              /* width: "100%" */
            }}
          >
            {resendingEmail ? (
              <>
                <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                Enviando...
              </>
            ) : (
              <>
                <EmailOutlined />
                Reenviar email
              </>
            )}
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mb-5">
        {/* {items?.map((item) => (
          <Card
            key={item.id}
            sx={{
              maxWidth: "350px",
              height: "auto",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              overflow: 'hidden'
            }}
            onClick={() => handleExpandImage(item.id)}
          >
            <div style={{ position: 'relative' }}>
              <img
                src={getItemImageUrl(item)}
                alt={item.codigo ? `Ticket ${item.id}` : `Voucher ${item.id}`}
                style={{
                  width: "100%",
                  display: "block",
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NotDesign;
                }}
              />
            </div>
            <CardContent>
              <h5 style={{
                fontWeight: 600,
                color: '#0B0060',
                marginBottom: '4px',
                fontFamily: "Bricolage Grotesque",
                fontSize: '18px'
              }}>
                {compra?.carrito?.evento?.evento}
              </h5>
              <p style={{
                color: '#525252',
                margin: '8px 0',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: "Bricolage Grotesque"
              }}>
                {item?.tarifa?.concepto}
              </p>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <CalendarTodayOutlined sx={{ fontSize: "14px", color: '#5656ff', marginRight: "5px" }} />
                <span style={{
                  fontSize: '14px',
                  color: '#525252',
                  fontFamily: "Bricolage Grotesque"
                }}>
                  {moment(item.tarifa?.fechas?.[0]?.fecha.hora_inicio).clone().local().format("MMMM DD, YYYY")}
                </span>
              </div>
              <div style={{
                marginTop: '12px',
                display: 'flex',
                textAlign: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                color: '#71717A',
                fontFamily: "Bricolage Grotesque"
              }}>
                <span>{item.codigo ? `Ticket #${item.id}` : `Voucher #${item.id}`}</span>
              </div>
            </CardContent>
          </Card>
        ))} */}
        <div>
          {renderItems(compra?.tickets, 'ticket')}
          {renderItems(compra?.vouchers, 'voucher')}
        </div>
      </div>
      <Modal
        open={expandedImage !== null}
        onClose={handleCloseImage}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            outline: 'none',
            width: '90%',
            maxWidth: '90vw',
            height: '90%',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          onClick={handleCloseImage}
        >
          {expandedImage && (
            <img
              src={getItemImageUrl(expandedImage)}
              alt={`Ticket expandido ${expandedImage}`}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                borderRadius: '8px'
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = NotDesign;
              }}
            />
          )}
          <div
            style={{
              marginTop: '20px',
              color: 'white',
              fontSize: '14px',
              textAlign: 'center',
              fontFamily: "Bricolage Grotesque",
              textShadow: '0 2px 4px rgba(0,0,0,0.5)'
            }}
          >
            (Haz clic en cualquier lugar para cerrar)
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default withAuthenticationRequired(ReciboVenta, {
  onRedirecting: () => <Loading />,
});